// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   Position Bar Container
================================ */
.position-bar {
  position: fixed;
  bottom: 0; /* At bottom of viewport */
  left: 0;
  right: 0;
  width: 100%;
  height: 40px;
  z-index: 999;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 60px;
  gap: 0;

  background: rgba(45, 45, 45, 0.441);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  /* border-top: 1px solid rgba(103, 61, 231, 0.2); */
}

/* ================================
   Position Bar Items
================================ */
.position-bar-item {
  padding: 8px 24px;
  margin: 0;
  border: none;
  background: transparent;
  color: rgba(101, 108, 123, 0.5); /* #656C7B 50% transparan */
  font-size: 16px;
  font-weight: 400;
  font-family: "Satoshi", sans-serif;
  cursor: pointer;
  transition: color 0.3s ease, background 0.3s ease;
  white-space: nowrap;
  position: relative;
}

.position-bar-item:hover {
  color: rgba(101, 108, 123, 0.8);
}

/* Active state */
.position-bar-item.active {
  color: #CCFF00;
  background: transparent;
}

.position-bar-item.active::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: #CCFF00;
}

/* ================================
   Mobile Responsive
================================ */
@media (max-width: 768px) {
  .position-bar {
    display: none !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/component/position-bar/position-bar.css"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;EACE,eAAe;EACf,SAAS,EAAE,0BAA0B;EACrC,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;;EAEN,mCAAmC;EACnC,2BAA2B;EAC3B,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA;;kCAEkC;AAClC;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,+BAA+B,EAAE,2BAA2B;EAC5D,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;;kCAEkC;AAClC;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ================================\n   Position Bar Container\n================================ */\n.position-bar {\n  position: fixed;\n  bottom: 0; /* At bottom of viewport */\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 40px;\n  z-index: 999;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 60px;\n  gap: 0;\n\n  background: rgba(45, 45, 45, 0.441);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  /* border-top: 1px solid rgba(103, 61, 231, 0.2); */\n}\n\n/* ================================\n   Position Bar Items\n================================ */\n.position-bar-item {\n  padding: 8px 24px;\n  margin: 0;\n  border: none;\n  background: transparent;\n  color: rgba(101, 108, 123, 0.5); /* #656C7B 50% transparan */\n  font-size: 16px;\n  font-weight: 400;\n  font-family: \"Satoshi\", sans-serif;\n  cursor: pointer;\n  transition: color 0.3s ease, background 0.3s ease;\n  white-space: nowrap;\n  position: relative;\n}\n\n.position-bar-item:hover {\n  color: rgba(101, 108, 123, 0.8);\n}\n\n/* Active state */\n.position-bar-item.active {\n  color: #CCFF00;\n  background: transparent;\n}\n\n.position-bar-item.active::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #CCFF00;\n}\n\n/* ================================\n   Mobile Responsive\n================================ */\n@media (max-width: 768px) {\n  .position-bar {\n    display: none !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
